import {Component, OnInit} from "@angular/core";
import { Location } from '@angular/common';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor(public location: Location,
              private titleService: Title) {}
  ngOnInit(): void {
    this.titleService.setTitle("Scalanthropy Page Not Found");
  }

  back(): void {
    this.location.back();
  }
}
